var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91668 1.25C7.82401 1.25 7.73401 1.28088 7.66089 1.33777L5.89872 2.70833H2.50001C1.57954 2.70833 0.833344 3.45452 0.833344 4.375V4.79167C0.833344 5.71212 1.57954 6.45833 2.50001 6.45833H5.89872L7.66089 7.82892C7.73401 7.88579 7.82401 7.91667 7.91668 7.91667H8.75001C8.98013 7.91667 9.16668 7.73012 9.16668 7.5V1.66667C9.16668 1.43655 8.98013 1.25 8.75001 1.25H7.91668Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50001 5.625C2.37015 5.625 2.24771 5.68554 2.16888 5.78875C2.09006 5.89196 2.06386 6.026 2.09803 6.15129L2.59742 7.98242C2.72102 8.43558 3.13264 8.75 3.60238 8.75H3.9734C4.66026 8.75 5.15909 8.09692 4.97834 7.43425L4.56868 5.93204C4.51922 5.75075 4.35459 5.625 4.16668 5.625H2.50001Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.2e2d79e5d5dfeb55b5fa47d50541ad76.svg";
export { ForwardRef as ReactComponent };